import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getCountApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/count`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getMonthTripApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/trip_month`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getTotalCostApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/cost_month`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getTripsOverviewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/trips_overview`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getVehicleOverviewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/vehicle_overview`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getCompleteOverviewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/trip_completion_overview`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getOverallCostApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/categorycost`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getVendorBasedTripApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/vendor_based`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripsApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `get_trips`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching trips:", err);
  } finally {
  }
};
